<template>
  <div class="finance-page">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('invest.recharge') }}
      </div>
      <div
        class="top_right"
        @click="$router.push('/rechargeRecord')"
      >
        <van-icon
          name="bars"
          size="25"
        />
      </div>
    </div>
    <div
      v-if="eye==1"
      class="balance"
    >
      <p>
        {{ utils_moneyMark() }} {{ balance }} 
      </p>
      <p>
        {{ $t('invest.availableBalance') }}
        <van-icon
          name="eye-o"
          @click="eye=0"
        />
      </p>
    </div>
    <div
      v-if="eye==0"
      class="balance"
    >
      <p>
        ******
      </p>
      <p>
        {{ $t('invest.availableBalance') }}
        <van-icon
          name="closed-eye"
          @click="eye=1"
        />
      </p>
    </div>
    <form class="form">
      <div class="recharge_wrap">
        <p>{{ $t('invest.rechargeAmount') }}</p>
        <div class="flex_center">
          <input
            v-model.trim="data.money"
            type="number"
            min="1"
            step="1"
            class="inp"
            :placeholder="$t('invest.rechargeAmount')"
            @input="changeAmount"
          >
          <!-- <span>{{actualAmount}}</span> -->
          <span>{{ payment.mark }}</span>
          <span>{{ actualAmount }}</span>
        </div>
      </div>
      <!-- <div class="recharge_wrap" v-if="data.channel!=5">
                <p>{{$t('invest.sendAddress')}}</p>
                <div class="flex_center">
                    <input v-model.trim="data.reason" type="text" class="reason"
                        :placeholder="$t('invest.sendAddress')">
                </div>
            </div> -->
      <div class="recharge_fs">
        <div class="tit">
          {{ $t('invest.paymentMethod') }}
        </div>
        <div
          v-for="(v, k) in config.payment"
          :key="k"
          class="item"
          @click="choose_type(k+1,v)"
        >
          <div
            class="check"
            :class="k+1 == data.choose? 'checked' : ''"
          />
          <div class="re_icon">
            <img :src="v.logo">
          </div>
          <div class="re_name">
            {{ v.name }}
          </div>
        </div>
      </div>
    </form>
    <div
      v-if="data.channel!=5"
      class="tip"
    >
      {{ $t('invest.tip') }}
    </div>
    <div
      class="basic_btn sbtn"
      @click="submit"
    >
      {{ $t('invest.next') }}
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import {
        CountDown,
        Checkbox,
        RadioGroup,
        Icon,
        Radio
    } from 'vant';
    import Fetch from '../../utils/fetch'

    Vue.use(RadioGroup);
    Vue.use(Radio);
    Vue.use(CountDown).use(Checkbox).use(Icon);

    export default {
        name: "Invest",
        data() {
            return {
                time: 0,
                eye: 1,
                balance: 0.00,
                data: {
                    choose: '',
                    channel: '',
                    money: '',
                    id: '',
                    reason:''
                },
                payment:[],
                config: {},
                actualAmount:'',
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
            var num = this.$router.history.current.params.code;
            if(num && num>0){
                this.data.money= num;
            }
        },
        methods: {
            start() {
                Fetch('/user/recharge', {
                    ...this.data
                }).then((r) => {
                    this.balance = r.data.money;
                    this.config = r.data;
                    this.config.min_recharge = parseInt(this.config.min_recharge);
                    this.choose_type(1,r.data.payment[0]);
                });
            },
            checkLimit() {
                const key = 'invest_button';
                const ttl = 60;
                let now = Date.parse(new Date()) / 1000;
                let val = localStorage.getItem(key);
                if (!val) {
                    val = JSON.stringify({
                        'ttl': now + ttl
                    })
                    localStorage.setItem(key, val)
                    return true;
                } else {
                    val = JSON.parse(val);
                    if (val['ttl'] > now) {
                        return false;
                    } else {
                        val = JSON.stringify({
                            'ttl': now + ttl
                        })
                        localStorage.setItem(key, val)
                        return true;
                    }
                }
            },
            choose_type(k, payment) {
                this.data.choose = k;
                this.data.channel = payment.type;
                this.data.id = payment.id;
                this.payment = payment;
                this.changeAmount();
            },
            submit() {
                if (!this.data.money || this.data.money < this.config.min_recharge) {
                    this.$toast(this.$t('invest.rechargeAmountLow') + this.utils_moneyMark() + this.config
                        .min_recharge + this.$t('invest.rechargeAmountLow1'));
                    return false;
                }
                if (!this.data.channel) {
                    this.$toast(this.$t('invest.paymentMethodEmpty'));
                    return false;
                }
                // if (!this.data.reason&&this.data.channel!=5) {
                //     this.$toast(this.$t('invest.sendAddress'));
                //     return false;
                // }
                // if (!this.checkLimit()) {
                //     this.$toast(this.$t('invest.overtop'));
                //     return false;
                // }
				this.$router.replace({
				    path: '/kefu',
				    query: {
				        money: this.data.money,
				        id: this.data.id
				    }
				})
				return;	
                if (this.data.channel == 4) {
                    this.$router.replace({
                        path: '/invest/bank',
                        query: {
                            money: this.data.money,
                            id: this.data.id
                        }
                    })
                    return;
                } else if (this.data.channel == 2) {
                    this.$router.replace({
                        path: '/invest/alipay',
                        query: {
                            money: this.data.money,
                            type: this.data.channel,
                            id: this.data.id
                        }
                    })
                    return;
                } else if (this.data.channel == 3) {
                    this.$router.replace({
                        path: '/invest/wx',
                        query: {
                            money: this.data.money,
                            type: this.data.channel,
                            id: this.data.id
                        }
                    })
                    return;
                } else if (this.data.channel == 1) {
                    this.$router.replace({
                        path: '/invest/usdt',
                        query: {
                            money: this.data.money,
                            id: this.data.id,
                            reason:this.data.reason
                        }
                    })
                    return;
                } else {
                    //第三方支付
          Fetch('/user/recharge_type', {
            money: this.data.money,
            id:this.data.id
          }).then((r) => {
              if(r.data.payment.payurl!=''){
                // window.open(r.data.payment.payurl,'_blank');
                window.location.href = r.data.payment.payurl;
              }
          });
                }
                // Fetch('/user/invest/apply', {
                //     ...this.data
                // }).then(() => {
                //     this.$router.replace('/login');
                // });
            },
            changeAmount() {
                var num = 2;
                if(this.payment.type){
                    if (this.payment.type == 1) {
                        if (this.payment.rate > 10000) {
                            num = 8;
                        } else if (this.payment.rate > 1000) {
                            num = 6;
                        } else if (this.payment.rate > 10) {
                            num = 4;
                        }
                        this.actualAmount = " ≈ " + (this.data.money / this.payment.rate).toFixed(num) + ' USD';
                    } else {
                        this.actualAmount = " ≈ " + this.payment.mark + (this.data.money / this.payment.rate).toFixed(num);
                    }
                }
            }
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg {
    }

    .balance {
        background: #ffffff;
        border-radius: 6px;
        padding: 20px 0px;
        margin: 10px;
        text-align: center;
        p:nth-child(1) {
            font-size: 26px;
            font-weight: bold;
            margin-bottom: 15px;
        }

        p:nth-child(2) {
            color: #999;
            font-weight: bold;
        }
    }

    .recharge_fs {
        margin-top: 10px;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        padding: 0 16px;
    }

    .recharge_box {
        width: 100%;
        height: 48px;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        margin-top: 12px;
        padding: 16px 11px;

        input {
            height: 18px;
            width: 100%;
            line-height: 18px;
            font-size: 14px;
        }
    }

    .form {
        margin: 10px;

        .recharge_wrap {
            width: 100%;
            background: #ffffff;
            border-radius: 6px;
            padding: 16px;
            margin-top: 10px;
            .flex_center {
              justify-content: flex-start;
            }
            .reason{
                width: 100%;
            }
            input {
                height: 18px;
                width: 40%;
                line-height: 18px;
                font-size: 14px;
            }
            div {
                span:nth-child(2){
                    font-size: 18px;
                    margin-right: 10px;
                    font-weight: bold;
                }
                // span:nth-child(3){
                //     font-size: 14px;
                //     width: 40%;
                //     color: #999;
                //     text-align: right;
                // }
            }

            p:nth-child(1) {
                font-size: 16px;
                font-weight: bold;
                color: #999;
                margin-bottom: 20px;
            }

            p:nth-child(3) {
                color: #999;
                margin-top: 20px;
            }

        }

        .tit {
            height: 54px;
            border-bottom: 1px solid #ECECEC;
            font-size: 16px;
            color: #999;
            font-weight: bold;
            line-height: 54px;
        }

        .item {
            height: 57px;
            border-bottom: 1px solid #ECECEC;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            &:last-child {
                border-bottom: none;
            }

            .check {
                width: 16px;
                height: 16px;
                margin-left: 4px;
                background: url(../images/user/c2.png) no-repeat center center;
                background-size: 100% 100%;

                &.checked {
                    background: url(../images/user/c1.png) no-repeat center center;
                    background-size: 100% 100%;
                }
            }

            .re_icon {
                width: 20px;
                height: 20px;
                margin-left: 11px;

                img {
                    width: 20px;
                    height: 20px;
                }
            }

            .re_name {
                font-size: 16px;
                line-height: 22px;
                color: rgba(0, 0, 0, .8);
                margin-left: 4px;
            }

            .wx {
                background: url(../images/user/recharge3.png) no-repeat center center;
                background-size: 100% 100%;
            }

            .alipay {
                background: url(../images/user/recharge2.png) no-repeat center center;
                background-size: 100% 100%;
            }

            .usdt {
                background: url(../images/user/recharge1.png) no-repeat center center;
                background-size: 100% 100%;
            }

            .alipay_app {
                background: url(../images/user/recharge2.png) no-repeat center center;
                background-size: 100% 100%;
            }

            .bank {
                background: url(../images/user/recharge4.png) no-repeat center center;
                background-size: 100% 100%;
            }
        }
    }
    .tip{
        display: block;
        margin: 8px;
        padding: 16px;
        border-radius: 16px;
        background-color: #FFFFFF;
        line-height: 24px;
        color: #ee264d;;
        font-size: 12px;
    }
    .sbtn {
        margin: 75px auto 0 auto;
    }

    .finance-page {
        min-height: 100vh;
        overflow-y: auto;
        padding-bottom: 88px;
        box-sizing: border-box;
        background: #f4f5fb;
        color: #061429;
    }

    .red_top_bg {
        position: sticky;
        top: 0;
        z-index: 10;
        height: 50px;
        background: #f7f8fd;
    }

    .big_tit {
        height: 50px;
        color: #202637;
        font-size: 14px;
        font-weight: 500;
        line-height: 50px;
    }

    .back_left {
        position: absolute;
        left: 8px;
        top: 10px;
        width: 28px;
        height: 28px;
        background: transparent;
    }

    .back_left::before {
        content: '';
        position: absolute;
        left: 9px;
        top: 7px;
        width: 10px;
        height: 10px;
        border-left: 2px solid #071426;
        border-bottom: 2px solid #071426;
        transform: rotate(45deg);
    }

    .top_right {
        top: 10px;
        right: 14px;
        width: 28px;
        height: 28px;
        color: #3e4656;
        font-size: 20px;
        line-height: 28px;
    }

    .balance,
    .form .recharge_wrap,
    .recharge_fs,
    .tip {
        overflow: hidden;
        border-radius: 12px;
        background: #fff;
        box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
    }

    .balance {
        margin: 16px 16px 0;
        padding: 18px 20px;
        text-align: left;
    }

    .balance p {
        margin: 0;
    }

    .balance p:nth-child(1) {
        overflow: hidden;
        color: #050b18;
        font-size: 14px;
        font-weight: 700;
        line-height: 24px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .balance p:nth-child(2) {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 6px;
        color: #8b93a3;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
    }

    .form {
        margin: 0 16px;
    }

    .form .recharge_wrap {
        width: 100%;
        margin-top: 16px;
        padding: 16px 18px;
        box-sizing: border-box;
    }

    .form .recharge_wrap p:nth-child(1),
    .form .tit {
        color: #8b93a3;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
    }

    .form .recharge_wrap .flex_center {
        min-height: 42px;
        justify-content: flex-start;
        margin-top: 8px;
        border-bottom: 1px solid #edf0f6;
    }

    .form .recharge_wrap input {
        flex: 1;
        width: auto;
        height: 34px;
        color: #050b18;
        font-size: 14px;
        line-height: 34px;
    }

    .form .recharge_wrap input::placeholder {
        color: #a4aab6;
    }

    .form .recharge_wrap div span:nth-child(2) {
        flex: 0 0 auto;
        margin-left: 10px;
        color: #050b18;
        font-size: 14px;
        font-weight: 700;
    }

    .form .recharge_wrap div span:nth-child(3) {
        min-width: 0;
        margin-left: 8px;
        overflow: hidden;
        color: #8b93a3;
        font-size: 12px;
        line-height: 18px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .recharge_fs {
        margin-top: 16px;
        padding: 0 18px;
    }

    .form .tit {
        height: 52px;
        border-bottom: 1px solid #edf0f6;
        line-height: 52px;
    }

    .form .item {
        height: 62px;
        border-bottom: 1px solid #edf0f6;
    }

    .form .item:last-child {
        border-bottom: 0;
    }

    .form .item .check {
        flex: 0 0 auto;
        margin-left: 0;
    }

    .form .item .re_icon {
        flex: 0 0 auto;
        margin-left: 12px;
    }

    .form .item .re_name {
        min-width: 0;
        overflow: hidden;
        color: #243049;
        font-size: 14px;
        line-height: 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .tip {
        margin: 16px;
        padding: 16px 18px;
        color: #ff4551;
        font-size: 12px;
        line-height: 20px;
    }

    .sbtn {
        width: calc(100% - 32px);
        height: 48px;
        margin: 24px 16px 0;
        border-radius: 12px;
        background: linear-gradient(135deg, #ffd909 0%, #ff9a0b 100%);
        box-shadow: 0 8px 20px rgba(255, 154, 11, .18);
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        line-height: 48px;
    }
</style>
